import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { url } from 'components/other/terms';
import { createBaseQueryWithReauth } from 'utils/baseQueryWithReauth';
export const billingsApi = createApi({
  reducerPath: 'billings',
  baseQuery: createBaseQueryWithReauth('/billing-plans'),
  refetchOnMountOrArgChange: true,
  refetchOnReconnect: false,
  keepUnusedDataFor: 1,

  endpoints: (builder) => ({

    // GET: List billing plans
    getBillingPlans: builder.query({
      query: () => '',
      providesTags: ['Billing'],
    }),

    // POST: Creating a new billing plan
    createBillingPlan: builder.mutation({
      query: (newPlan) => ({
        url: '/create',
        method: 'POST',
        body: newPlan,
      }),
      invalidatesTags: ['Billing'],
    }),

    // POST: Updating an existing billing plan
    updateBillingPlan: builder.mutation({
      query: ({ id, ...updateData }) => ({
        url: `/update?id=${id}`,
        method: 'POST',
        body: updateData,
      }),
      invalidatesTags: ['Billing'],
    }),

    // POST: Deleting a billing plan
    deleteBillingPlan: builder.mutation({
      query: (id) => ({
        url: `/delete?id=${id}`,
        method: 'POST',
      }),
      invalidatesTags: ['Billing'],
    }),
  }),
});

export const {
  useGetBillingPlansQuery,
  useCreateBillingPlanMutation,
  useUpdateBillingPlanMutation,
  useDeleteBillingPlanMutation,
} = billingsApi;
